import FieldProto from "../../fields3/proto/field-proto";
import {SortDirection} from "../sort";
import ModelEntity from "../../model2/model-entity";

const debug = false
// const debug = "sortByOperator"

export default function sortByOperator(models:ModelEntity[], field:FieldProto, sortDirection:SortDirection) {
    debug && console.log(debug, 'process() total models=', _.size(models), field, sortDirection)

    const fieldId = field.fieldId

    const result = _.orderBy(models,(model)=>{

        // @ts-ignore
        const value = model[fieldId]

        return field.sortValue(value, model)

    })


    debug && console.log(debug, 'process result', result)

    return result
}
